/**
 * ╔══════════════════════════════════════════════════════════════════╗
 * ║          PC — Collection Data  (pc-collection-data.js)          ║
 * ║                                                                  ║
 * ║  在这里控制每个 Collection 的：                                    ║
 * ║    · 自定义产品排列顺序  (order)                                   ║
 * ║    · 每张产品卡右上角的 badge 文字 (badges)                        ║
 * ║                                                                  ║
 * ║  使用说明：                                                        ║
 * ║  1. 把此文件上传到 Shopify → 主题 → Assets                         ║
 * ║  2. key 值 = Collection 的 handle（URL 里的小写短横线名称）          ║
 * ║  3. order[] 里填 product handle，从上到下 = 第1格到最后一格          ║
 * ║     · 没有列出的产品会自动追加到末尾（按 Shopify 默认顺序）           ║
 * ║     · 想隐藏某产品？直接不填即可（仍会追加，除非 Shopify 已下架）     ║
 * ║  4. badges{} 里 key = product handle，value = 右上角显示的文字      ║
 * ║     · 留空 "" 或不填 = 不显示 badge                                 ║
 * ║     · 支持任意语言文字                                              ║
 * ╚══════════════════════════════════════════════════════════════════╝
 */

/* ══════════════════════════════════════════════════════════════════
   評論資料（原 pc-reviews-data.js 內容，已合併至此，無需另外載入）
   ══════════════════════════════════════════════════════════════════ */
window.PCReviews = [
  {
    "id": 1,
    "ol": "it",
    "ob": "L'articolo e' molto meglio di quello che mi aspettavo! Ottimo pack di presentazione e servizio clienti eccellente.",
    "r": 5,
    "n": "Rebecca",
    "p": "delta",
    "d": "2025-09-19"
  },
  {
    "id": 2,
    "ol": "it",
    "ob": "oggetto fedele alla descrizione, buon prodotto",
    "r": 5,
    "n": "francesco",
    "p": "delta",
    "d": "2025-12-28"
  },
  {
    "id": 3,
    "r": 5,
    "n": "Rebecca Moon",
    "p": "delta",
    "d": "2025-10-25"
  },
  {
    "id": 4,
    "r": 5,
    "n": "ALINE",
    "p": "delta",
    "d": "2025-11-27"
  },
  {
    "id": 5,
    "r": 5,
    "n": "sofia",
    "p": "delta",
    "d": "2025-09-13"
  },
  {
    "id": 6,
    "r": 5,
    "n": "Roberta Mozzillo",
    "p": "delta",
    "d": "2025-10-05"
  },
  {
    "id": 7,
    "r": 5,
    "n": "valeria",
    "p": "delta",
    "d": "2025-12-29"
  },
  {
    "id": 8,
    "r": 5,
    "n": "Alan Davies",
    "p": "delta",
    "d": "2025-08-20"
  },
  {
    "id": 9,
    "r": 5,
    "n": "Sign in with Apple user",
    "p": "delta",
    "d": "2025-11-29"
  },
  {
    "id": 10,
    "r": 5,
    "n": "angelaleggieri1",
    "p": "delta",
    "d": "2025-11-19"
  },
  {
    "id": 11,
    "r": 5,
    "n": "Y",
    "p": "capsule",
    "d": "2025-11-22"
  },
  {
    "id": 12,
    "r": 5,
    "n": "Adelina",
    "p": "capsule",
    "d": "2025-12-26"
  },
  {
    "id": 13,
    "r": 5,
    "n": "Vittoria Luce Menegatti",
    "p": "orbit",
    "d": "2025-10-24"
  },
  {
    "id": 14,
    "r": 5,
    "n": "The Doctor",
    "p": "orbit",
    "d": "2025-10-13"
  },
  {
    "id": 15,
    "r": 5,
    "n": "Nicole Giannino",
    "p": "orbit",
    "d": "2025-12-31"
  },
  {
    "id": 16,
    "r": 5,
    "n": "Vikki Mclntosh",
    "p": "orbit",
    "d": "2025-11-26"
  },
  {
    "id": 17,
    "r": 5,
    "n": "Marta",
    "p": "orbit",
    "d": "2025-11-21"
  },
  {
    "id": 18,
    "r": 5,
    "n": "Marcella",
    "p": "orbit",
    "d": "2025-12-22"
  },
  {
    "id": 19,
    "r": 5,
    "n": "vera zoroaster",
    "p": "orbit",
    "d": "2025-09-23"
  },
  {
    "id": 20,
    "r": 5,
    "n": "Balestrieri Stefania",
    "p": "orbit",
    "d": "2025-12-28"
  },
  {
    "id": 21,
    "r": 5,
    "n": "Melanie",
    "p": "orbit",
    "d": "2025-09-18"
  },
  {
    "id": 22,
    "r": 5,
    "n": "Bella Breault",
    "p": "store",
    "d": "2025-09-11"
  },
  {
    "id": 23,
    "r": 5,
    "n": "James Harling",
    "p": "store",
    "d": "2026-01-08"
  },
  {
    "id": 24,
    "r": 5,
    "n": "Martina Bellagamba",
    "p": "store",
    "d": "2025-08-16"
  },
  {
    "id": 25,
    "r": 5,
    "n": "Maggie",
    "p": "store",
    "d": "2025-07-19"
  },
  {
    "id": 26,
    "r": 5,
    "n": "Grace",
    "p": "store",
    "d": "2025-12-29"
  },
  {
    "id": 27,
    "r": 5,
    "n": "Veri Farins",
    "p": "store",
    "d": "2025-10-04"
  },
  {
    "id": 28,
    "r": 5,
    "n": "Anne Donahue",
    "p": "store",
    "d": "2025-12-26"
  },
  {
    "id": 29,
    "r": 5,
    "n": "Jaime DeCecco",
    "p": "store",
    "d": "2025-10-11"
  },
  {
    "id": 30,
    "r": 5,
    "n": "Lucy",
    "p": "store",
    "d": "2025-12-27"
  },
  {
    "id": 31,
    "r": 5,
    "n": "Pascale M. Koop",
    "p": "store",
    "d": "2025-07-20"
  },
  {
    "id": 32,
    "r": 5,
    "n": "debbie gaetz",
    "p": "store",
    "d": "2025-12-04"
  },
  {
    "id": 33,
    "r": 4,
    "n": "Jenna McLoskey",
    "p": "store",
    "d": "2025-09-21"
  },
  {
    "id": 34,
    "r": 5,
    "n": "Nikoletta",
    "p": "store",
    "d": "2025-10-18"
  },
  {
    "id": 35,
    "r": 5,
    "n": "Mengjin Huang",
    "p": "store",
    "d": "2025-12-04"
  },
  {
    "id": 36,
    "r": 5,
    "n": "faye",
    "p": "store",
    "d": "2025-12-17"
  },
  {
    "id": 37,
    "r": 5,
    "n": "polyhymnia",
    "p": "store",
    "d": "2026-01-07"
  },
  {
    "id": 38,
    "r": 5,
    "n": "Roberta",
    "p": "store",
    "d": "2025-12-18"
  },
  {
    "id": 39,
    "r": 5,
    "n": "Jacqueline",
    "p": "store",
    "d": "2025-12-17"
  },
  {
    "id": 40,
    "r": 4,
    "n": "Francesca Sara",
    "p": "acoustic",
    "d": "2025-08-10"
  },
  {
    "id": 41,
    "r": 5,
    "n": "Lindsey",
    "p": "acoustic",
    "d": "2025-12-15"
  },
  {
    "id": 42,
    "r": 5,
    "n": "Jonas Verbeken",
    "p": "acoustic",
    "d": "2026-01-01"
  },
  {
    "id": 43,
    "r": 5,
    "n": "katenesstone",
    "p": "acoustic",
    "d": "2025-12-15"
  },
  {
    "id": 44,
    "r": 5,
    "n": "A B",
    "p": "acoustic",
    "d": "2025-12-30"
  },
  {
    "id": 45,
    "r": 5,
    "n": "Vania M.",
    "p": "crown",
    "d": "2025-10-22"
  },
  {
    "id": 46,
    "r": 5,
    "n": "joyfthomas",
    "p": "crown",
    "d": "2025-10-24"
  },
  {
    "id": 47,
    "r": 5,
    "n": "Mary J Nord",
    "p": "crown",
    "d": "2026-01-13"
  },
  {
    "id": 48,
    "r": 5,
    "n": "Yvonne",
    "p": "crown",
    "d": "2025-08-18"
  },
  {
    "id": 49,
    "r": 5,
    "n": "chriiss",
    "p": "crown",
    "d": "2025-11-18"
  },
  {
    "id": 50,
    "r": 5,
    "n": "Nikki Lee",
    "p": "crown",
    "d": "2025-09-15"
  },
  {
    "id": 51,
    "r": 5,
    "n": "Lee",
    "p": "crown",
    "d": "2025-09-18"
  },
  {
    "id": 52,
    "r": 5,
    "n": "Nataly Reyes",
    "p": "crown",
    "d": "2025-09-23"
  },
  {
    "id": 53,
    "r": 5,
    "n": "J H",
    "p": "crown",
    "d": "2025-10-14"
  },
  {
    "id": 54,
    "r": 5,
    "n": "Jody",
    "p": "crown",
    "d": "2025-09-11"
  },
  {
    "id": 55,
    "r": 5,
    "n": "Lilly",
    "p": "solo",
    "d": "2026-01-10"
  },
  {
    "id": 56,
    "r": 5,
    "n": "Laura Grayson",
    "p": "solo",
    "d": "2026-01-06"
  },
  {
    "id": 57,
    "r": 5,
    "n": "Belinda Martin",
    "p": "solo",
    "d": "2025-12-04"
  },
  {
    "id": 58,
    "r": 5,
    "n": "Meg Brunelle",
    "p": "cube",
    "d": "2026-01-04"
  },
  {
    "id": 59,
    "r": 5,
    "n": "Susan Schmitt",
    "p": "cube",
    "d": "2025-09-15"
  },
  {
    "id": 60,
    "r": 5,
    "n": "Jennifer",
    "p": "cube",
    "d": "2025-12-23"
  },
  {
    "id": 61,
    "r": 5,
    "n": "cecile",
    "p": "acoustic",
    "d": "2025-08-09"
  },
  {
    "id": 62,
    "r": 5,
    "n": "Henri MASSET",
    "p": "cube",
    "d": "2025-12-09"
  },
  {
    "id": 63,
    "r": 5,
    "n": "Rachel",
    "p": "cube",
    "d": "2025-12-24"
  },
  {
    "id": 64,
    "r": 5,
    "n": "Sandi Brereton Art",
    "p": "acoustic",
    "d": "2025-12-16"
  },
  {
    "id": 65,
    "r": 5,
    "n": "Mara",
    "p": "acoustic",
    "d": "2026-01-05"
  },
  {
    "id": 66,
    "r": 5,
    "n": "Jocelyn Alvarez",
    "p": "acoustic",
    "d": "2025-12-19"
  },
  {
    "id": 67,
    "r": 5,
    "n": "Ess Bee",
    "p": "acoustic",
    "d": "2025-12-21"
  },
  {
    "id": 68,
    "r": 5,
    "n": "Tina Clevinger Roberts",
    "p": "crown",
    "d": "2025-08-15"
  },
  {
    "id": 69,
    "r": 5,
    "n": "Debbie Beckett",
    "p": "crown",
    "d": "2025-12-13"
  },
  {
    "id": 70,
    "r": 5,
    "n": "kylee starks",
    "p": "crown",
    "d": "2026-01-24"
  },
  {
    "id": 71,
    "r": 5,
    "n": "Tonia",
    "p": "crown",
    "d": "2025-08-12"
  },
  {
    "id": 72,
    "r": 5,
    "n": "Sherrie Palmer",
    "p": "crown",
    "d": "2025-09-08"
  },
  {
    "id": 73,
    "r": 5,
    "n": "Margeri Ottis",
    "p": "crown",
    "d": "2025-10-11"
  },
  {
    "id": 74,
    "r": 5,
    "n": "Vicki",
    "p": "crown",
    "d": "2025-12-05"
  },
  {
    "id": 75,
    "r": 5,
    "n": "Heather Price",
    "p": "crown",
    "d": "2025-09-27"
  },
  {
    "id": 76,
    "r": 5,
    "n": "Greta",
    "p": "crown",
    "d": "2025-12-03"
  },
  {
    "id": 77,
    "r": 5,
    "n": "Teresa Willebeek-LeMair",
    "p": "crown",
    "d": "2025-11-03"
  },
  {
    "id": 78,
    "r": 5,
    "n": "Giovanni",
    "p": "crown",
    "d": "2025-09-24"
  },
  {
    "id": 79,
    "r": 5,
    "n": "Stephanie",
    "p": "crown",
    "d": "2025-11-18"
  },
  {
    "id": 80,
    "r": 5,
    "n": "HANJUN NI",
    "p": "crown",
    "d": "2025-11-17"
  },
  {
    "id": 81,
    "r": 5,
    "n": "Filip Selen",
    "p": "crown",
    "d": "2025-12-01"
  },
  {
    "id": 82,
    "r": 5,
    "n": "mariakn1809",
    "p": "crown",
    "d": "2025-11-23"
  },
  {
    "id": 83,
    "r": 5,
    "n": "Natale",
    "p": "noir",
    "d": "2025-12-22"
  },
  {
    "id": 84,
    "r": 5,
    "n": "Jessica",
    "p": "crown",
    "d": "2026-02-01"
  }
];

window.PCBadgeI18n = {
  "New Release": {
    "ar":    "إصدار جديد",
    "de":    "Neuerscheinung",
    "es":    "Nuevo lanzamiento",
    "fr":    "Nouvelle sortie",
    "he":    "מהדורה חדשה",
    "it":    "Nuova uscita",
    "ja":    "新発売",
    "pt-PT": "Novo lançamento",
    "ru":    "Новинка",
    "zh-TW": "全新上市"
  },
  "Best Seller": {
    "ar":    "الأكثر مبيعاً",
    "de":    "Bestseller",
    "es":    "Más vendido",
    "fr":    "Meilleure vente",
    "he":    "רב מכר",
    "it":    "Più venduto",
    "ja":    "ベストセラー",
    "pt-PT": "Mais vendido",
    "ru":    "Бестселлер",
    "zh-TW": "熱銷商品"
  },
  "Featured": {
    "ar":    "مميز",
    "de":    "Empfohlen",
    "es":    "Destacado",
    "fr":    "Sélection",
    "he":    "מומלץ",
    "it":    "In evidenza",
    "ja":    "注目商品",
    "pt-PT": "Destaque",
    "ru":    "Рекомендуем",
    "zh-TW": "精選商品"
  }
};

/* ══════════════════════════════════════════════════════════════════
   自動 Badge 邏輯（根據 pc-reviews-data.js 的評論陣列）
   資料格式：window.PCReviews = [ { p: "product-handle", ... }, ... ]
   · 評論數 > 20       → "Best Seller"
   · 評論數 6 ~ 20     → "Featured"
   · 評論數 ≤ 5        → "New Release"
   · 找不到評論資料    → "" (不顯示)
   ══════════════════════════════════════════════════════════════════ */

/* 第一步：把 PCReviews 陣列統計成 { handle: count } 的查找表 */
window.PCBuildReviewCounts = function() {
  var reviews = window.PCReviews;
  if (!reviews || !Array.isArray(reviews)) return {};

  var counts = {};
  reviews.forEach(function(review) {
    var handle = review.p;
    if (!handle) return;
    counts[handle] = (counts[handle] || 0) + 1;
  });
  return counts;
};

/* 第二步：根據評論數回傳對應 badge */
window.PCGetAutoBadge = function(handle, counts) {
  var count = counts[handle];
  if (count === undefined) return "New Release";
  if (count > 20)  return "Best Seller";
  if (count <= 5)  return "New Release";
  return "Featured";
};

/* 第三步：自動填充所有 Collection 的 badges */
window.PCAutoFillBadges = function() {
  var colData = window.PCCollectionData;
  if (!colData) return;

  var counts = window.PCBuildReviewCounts();

  Object.keys(colData).forEach(function(col) {
    var collection = colData[col];
    if (!collection.order) return;

    collection.badges = {};
    collection.order.forEach(function(handle) {
      collection.badges[handle] = window.PCGetAutoBadge(handle, counts);
    });
  });
};

// ↓ PCAutoFillBadges() 移到檔案最末尾，確保 PCCollectionData 已定義

window.PCCollectionData = {

  /* ─────────────────────────────────────────────────────────────────
     Collection: cases
     ───────────────────────────────────────────────────────────────── */
  "cases": {
    order: [
      "tailormade",
      "gallery",
      "crown",
      "acoustic",
      "orbit",
      "cube",
      "solo",
      "capsule",
      "repertoire",
      "dewdrop",
      "diamond",
      "axe",
      "outline",
      "teddy",
      "classic",
    ],
    badges: {} // 由 PCAutoFillBadges 根據評論數自動填充
  },

  /* ─────────────────────────────────────────────────────────────────
     Collection: keepsakes
     ───────────────────────────────────────────────────────────────── */
  "keepsakes": {
    order: [
      "watchman",
      "clover",
      "elevated",
      "unrooted",
      "forbidden",
      "melting",
      "sphere",
      "guiding",
      "signature",
      "balance",
      "wingspan",
      "drift",
    ],
    badges: {} // 由 PCAutoFillBadges 根據評論數自動填充
  },

  /* ─────────────────────────────────────────────────────────────────
     Collection: picks
     ───────────────────────────────────────────────────────────────── */
  "picks": {
    order: [
      "heart",
      "maple",
      "iridescent",
      "champagne",
      "raven",
      "amber",
      "void",
      "opal",
      "citrine",
      "ruby",
      "tanzanite",
      "peridot",
      "aquamarine",
      "morganite",
      "porcelain",
      "serpentine",
      "carnelian",
      "noir",
    ],
    badges: {} // 由 PCAutoFillBadges 根據評論數自動填充
  },

  /* ─────────────────────────────────────────────────────────────────
     Collection: pouches
     ───────────────────────────────────────────────────────────────── */
  "pouches": {
    order: [
      "horizon",
      "forest",
      "delta",
      "cognac",
    ],
    badges: {} // 由 PCAutoFillBadges 根據評論數自動填充
  }

  /* ─────────────────────────────────────────────────────────────────
     继续添加更多 Collection：复制上面的块，修改 handle 和内容即可
     ───────────────────────────────────────────────────────────────── */

};

// 所有資料已定義完畢，現在執行 badge 自動填充
window.PCAutoFillBadges();